import { useCallback, useEffect, useState } from "react";

const useImageSelection = ({
  images,
  isMultiSelect = false,
  onSelectionChange,
}) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [startIndex, setStartIndex] = useState(null);

  const onImageClick = useCallback(
    (e, imageId) => {
      setSelectedImages((prev) => {
        if (!isMultiSelect) {
          return [imageId];
        }

        if (e.ctrlKey || e.metaKey) {
          return [...prev, imageId];
        }

        if (e.shiftKey && prev.length > 0) {
          const nextIndex = images.findIndex((image) => image.id === imageId);
          const newSelectedImages =
            startIndex < nextIndex
              ? images.slice(startIndex, nextIndex + 1)
              : images.slice(nextIndex, startIndex + 1);
          return newSelectedImages.map((image) => image.id);
        }

        setStartIndex(images.findIndex((image) => image.id === imageId));

        return [imageId];
      });
    },
    [images, isMultiSelect, startIndex]
  );

  useEffect(() => {
    if (selectedImages.length > 0) {
      onSelectionChange?.(
        isMultiSelect
          ? images.filter((image) => selectedImages.includes(image.id))
          : images.find((image) => selectedImages.includes(image.id))
      );
    }
  }, [selectedImages, onSelectionChange, images, isMultiSelect]);

  return {
    selectedImages,
    setSelectedImages,
    startIndex,
    setStartIndex,
    onImageClick,
  };
};

export default useImageSelection;
